import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { CircularProgress, IconButton } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import * as auth from "../../store/ducks/auth.duck";
import { forgotPassword } from "../../crud/auth.crud";
import { useHistory } from "react-router-dom";
import SwAlert from "../../components/SwAlert";
import { createFormikValidation } from "../../utils/Utils";
import CustomInput from "../../components/CustomInput";

const EsqueceuSenha = () => {
	const [loading, setLoading] = useState(false);
	const history = useHistory();

	const onSubmit = (values) => {
		setLoading(true);

		forgotPassword(values.email)
			.then(() => {
				SwAlert({
					title: `Se o e-mail existe no sistema, será enviado o código para redefinição de senha.`,
					confirmButtonText: "Fechar",
					icon: "success",
					customClass: {
						content: "p-0 pb-32",
					},
					timer: 3000,
				});

				history.push(`/esqueceu-senha-codigo?email=${values.email}`);
			})
			.catch((err) => {
				setLoading(false);

				SwAlert({
					title: (err?.response?.data?.errors && err?.response?.data?.errors[0]) ?? `Parece que houve um problema`,
					text: err?.response?.data?.errors ? null : "Por favor, entre em contato com o suporte.",
					customClass: {
						content: err?.response?.data?.errors ? "p-0 pb-32" : ""
					},
					confirmButtonText: "Fechar",
					icon: "error",
				});
			});
	};

	const getInitialValues = () => {
		return {
			email: "",
		};
	};

	const validate = (values) => {
		let map = new Map();

		map.set("email", "e-mail");

		return createFormikValidation(map, values);
	};

	return (
		<div class="authContainerContainer">
			<div className="esqueceuSenhaContainer">
				<div>
					<IconButton onClick={() => history.push("/login")} className="p-0">
						<div className="d-flex gap-8 align-items-center color-dark-6">
							<ArrowBackIosIcon style={{ color: "#9CA3AF", fontSize: 14 }} />

							<span className={`tt-16 medium`}>Voltar</span>
						</div>
					</IconButton>
				</div>

				<div className="d-flex flex-column gap-12">
					<span className={`tt-24 semibold color-white`}>Recuperar senha</span>

					<span className={`tt-16 color-dark-6`}>Informe seu e-mail da conta para recuperar sua senha. Um código será enviado para você prosseguir.</span>
				</div>

				<Formik initialValues={getInitialValues()} validate={validate} onSubmit={onSubmit}>
					{({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
						<form noValidate autoComplete="off" onSubmit={handleSubmit} className="d-flex flex-column gap-40">
							<div className="d-flex flex-column gap-24">
								<CustomInput placeholder="Informe seu e-mail" label="E-mail" name="email" type="email" value={values.email} handleBlur={handleBlur} handleChange={handleChange} errors={errors} touched={touched} disabled={loading} />
							</div>

							<button type="submit" disabled={loading} className="btn btn-primary btn-large tt-16 medium">
								{loading ? <CircularProgress size={14} className="margin-icon" style={{ color: "#fff" }} /> : ""}Enviar código
							</button>
						</form>
					)}
				</Formik>
			</div>
		</div>
	);
};

export default connect(null, auth.actions)(EsqueceuSenha);
